import BaseEntity from '@/entities/BaseEntity';
import User from '@/entities/User';

export default class LeadgenFormLeadActivity extends BaseEntity {
  static TYPE_STATUS_CHANGED = 'status_changed';
  static TYPE_ASSIGNED = 'assigned';
  static TYPE_COMMENT = 'comment';
  static TYPE_CONVERSION_SENT = 'conversion_sent';
  static TYPE_CONVERSION_FAILED = 'conversion_failed';

  id = null;
  type = null;
  user = null;
  details = {};
  created_at = null;

  _entityFields = {
    user: User,
  };

  constructor(rawData) {
    super();
    this.updateWith(rawData);
  }
}
